import { Component } from '@builder.io/sdk';

export const config: Component = {
    name: 'Value Props',
    inputs: [
        {
            name: 'valueProps',
            type: 'list',
            subFields: [
                {
                    name: 'text',
                    type: 'string',
                    required: true,
                    helperText: 'The text for the value prop.',
                },
                {
                    name: 'icon',
                    type: 'file',
                    allowedFileTypes: ['png', 'jpg', 'jpeg', 'svg'],
                    required: true,
                    helperText: 'The icon for the value prop.',
                },
            ],
            onChange: (options) => {
                if (options.get('valueProps').length > 3) {
                    options.set('valueProps', options.get('valueProps').slice(0, 3));
                    alert('Maximum number of value props is 3. Modify an existing value prop instead.');
                }
            },
            required: true,
            defaultValue: [
                {
                    text: 'Value Prop Text',
                    icon: '',
                },
            ],
            helperText: 'List of value props to display.',
        },
    ],
};
